import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import axios from 'axios';

// Components
import Navbar from '../navbar/Navbar';
import Loader from '../loader/Loader';
import SettingsSidebar from '../sidebar/SettingsSidebar';

// Action imports
import { updateProfile, getUser } from '../../actions/auth';

// CSS
import '../../css/landing/landing.css';
import '../../css/userDetails/planAndBilling.css';

const PlanAndBilling = ({
  auth: { isAuthenticated, user },
  getUser,
  updateProfile,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [planData, setPlanData] = useState([]);

  // Fetch API Key on page load
  useEffect(() => {
    const fetchAPIKey = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URI}/ecomnext/api/user-subscription-details`
        );

        if (response.data?.data) {
          setPlanData(response.data.data); // Store all subscription records
        }
      } catch (error) {
        console.error('Error fetching Plan Details:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAPIKey();
  }, []);

  const getDaysUntilExpiration = (endDate) => {
    const today = new Date();
    const expirationDate = new Date(endDate);
    const diffTime = expirationDate - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <SettingsSidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <div>
              <Navbar />
            </div>

            {/* Main Content */}
            <div className='plan-bill-page-wrapper flex-1 bg-white p-6'>
              {/* Heading */}
              <h1 className='plan-bill-page-heading'>Plan & Billing</h1>
              <hr />

              {/* Loop Through All Subscription Records */}
              {planData.map((plan, index) => (
                <div key={index} className='plan-details-wrapper mt-6'>
                  {/* Expiration Notice */}
                  {getDaysUntilExpiration(plan.end_date) <= 10 && (
                    <div
                      className={`py-2 px-3 ${
                        getDaysUntilExpiration(plan.end_date) <= 0
                          ? 'plan-bill-expired-note'
                          : 'plan-bill-expire-note'
                      }`}
                    >
                      {getDaysUntilExpiration(plan.end_date) <= 0
                        ? 'Your subscription got expired'
                        : `Your current subscription will expire in ${getDaysUntilExpiration(
                            plan.end_date
                          )} days.`}
                    </div>
                  )}

                  {/* Plan Details */}
                  <div className='plan-details-wrapper-div'>
                    {/* Heading with Platform Name */}
                    <div className='plan-details-heading-text'>
                      Your subscription details -{' '}
                      {plan.platform_name.charAt(0).toUpperCase() +
                        plan.platform_name.slice(1)}
                    </div>
                    <hr className='mb-8' />

                    {/* Plan Details Content */}
                    <div className='flex justify-between mb-12'>
                      {/* Current Plan */}
                      <div>
                        <label className='plan-bill-label-text block'>
                          Plan Name
                        </label>
                        <p className='plan-bill-label-value'>
                          {plan.plan_name}
                        </p>
                      </div>

                      {/* Start Date */}
                      <div>
                        <label className='plan-bill-label-text block'>
                          Start Date
                        </label>
                        <p className='plan-bill-label-value'>
                          {new Date(plan.start_date).toLocaleDateString()}
                        </p>
                      </div>

                      {/* End Date */}
                      <div>
                        <label className='plan-bill-label-text block'>
                          End Date
                        </label>
                        <p className='plan-bill-label-value'>
                          {new Date(plan.end_date).toLocaleDateString()}
                        </p>
                      </div>

                      {/* Platform Name (Newly Added) */}
                      <div>
                        <label className='plan-bill-label-text block'>
                          Platform Name
                        </label>
                        <p className='plan-bill-label-value'>
                          {plan.platform_name}
                        </p>
                      </div>

                      {/* Remaining Tokens */}
                      <div>
                        <label className='plan-bill-label-text block'>
                          Tokens Remaining
                        </label>
                        <p className='plan-bill-label-value'>
                          {plan.remaining_tokens}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { getUser, updateProfile })(
  PlanAndBilling
);
